import { render, staticRenderFns } from "./addRemove.vue?vue&type=template&id=5ac0cff2&"
import script from "./addRemove.vue?vue&type=script&lang=js&"
export * from "./addRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports